import styled from 'styled-components';

const Style = styled.div`
  display: flex;
  flex-direction: column;

  p {
    margin: 0;
  }
  
  .text {
    font-size: 14px;
    line-height: 20px;
    color: var(--base-gray-90);
    font-weight: 500;

    &.not-answered {
      color: var(--base-gray-50);
    }
  }

  &.default-comment {
    margin-top: 8px;
  }
`;

export const ToggledTextStyle = styled.div`
  button {
    width: fit-content;
    float: right;
    font-size: 14px;
    align-self: flex-end;
    margin-top: 12px;
    span[role="img"] {
      font-size: 14px !important;
      margin: 0 !important;
      
      svg {
        margin-top: -3px;
        width: 14px;
        height: 14px;
      }
    }
  }

  &.details-view button svg {
    margin-top: -5px !important;
  }
`;

export default Style;
